import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "user_panel"
};
const _hoisted_2 = {
  class: "user_panel_tab"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  style: {
    "width": "884px",
    "margin": "0 30px"
  }
};
const _hoisted_5 = ["src", "onClick"];
const _hoisted_6 = {
  class: "user"
};
const _hoisted_7 = {
  class: "user_tx"
};
const _hoisted_8 = {
  class: "user_data"
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "baseline"
  }
};
const _hoisted_10 = {
  style: {
    "font-size": "24px",
    "margin-bottom": "0",
    "position": "relative",
    "top": "2px"
  }
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "baseline"
  }
};
const _hoisted_12 = {
  style: {
    "font-size": "24px",
    "margin-bottom": "0",
    "position": "relative",
    "top": "2px"
  }
};
const _hoisted_13 = {
  key: 1,
  style: {
    "width": "90%",
    "margin-top": "30px"
  }
};
const _hoisted_14 = ["onClick", "src"];
const _hoisted_15 = {
  key: 2,
  src: "https://www.mimodental.com/assets/imgData/img/member_index/text.png",
  alt: "",
  class: "text"
};
const _hoisted_16 = {
  key: 3,
  style: {
    "display": "flex",
    "width": "90%",
    "justify-content": "space-between",
    "margin-top": "30px",
    "align-items": "center"
  }
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 0,
  class: "wz_sc"
};
const _hoisted_20 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_el_carousel = _resolveComponent("el-carousel");
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  return _openBlock(), _createElementBlock("div", {
    class: "index_body",
    style: _normalizeStyle('background:' + ($setup.Client == 1 ? '#fff;' : 'none;') + 'min-width:' + ($setup.Client == 1 ? '' : '1560px;'))
  }, [$setup.Client == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      style: {
        "cursor": "pointer"
      },
      onClick: $event => $setup.go(item.go)
    }, [_createVNode(_component_van_image, {
      width: "25px",
      src: 'https://www.mimodental.com/assets/imgData/img/header/' + item.key + '@2x.png'
    }, null, 8, ["src"]), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 8, _hoisted_3);
  }), 128))]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_carousel, {
    height: "15.5vw"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lun, (item, index) => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        key: index,
        style: {
          "cursor": "pointer"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: item.imgUrlPc,
          style: {
            "width": "100%"
          },
          onClick: $event => $setup.lungo(item.gotoPc),
          alt: ""
        }, null, 8, _hoisted_5)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/header/tx.png",
    alt: ""
  }, null, -1)), _createElementVNode("span", null, "Hi," + _toDisplayString($setup.user_info.name || $setup.user_info.phone), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = $event => $setup.go('member_preferential'))
  }, [_createElementVNode("span", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString($setup.user_info.params.countKaquan), 1), _cache[5] || (_cache[5] = _createElementVNode("span", null, "张", -1))]), _cache[6] || (_cache[6] = _createElementVNode("span", null, "优惠券", -1))]), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = $event => $setup.go('member_userCard'))
  }, [_createElementVNode("span", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString($setup.userCard_list), 1), _cache[7] || (_cache[7] = _createElementVNode("span", null, "张", -1))]), _cache[8] || (_cache[8] = _createElementVNode("span", null, "我的套餐卡", -1))])]), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.call && $setup.call(...args))
  }, _cache[9] || (_cache[9] = [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/member_index/kf.png",
    alt: ""
  }, null, -1), _createElementVNode("span", null, "联系专属客服", -1)]))])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_van_swipe, {
    style: {
      "border-radius": "30px"
    },
    autoplay: 3000,
    "indicator-color": "white"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lun, (item, index) => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          onClick: $event => $setup.lungo(item.gotoM),
          style: {
            "width": "100%"
          },
          src: item.imgUrlM,
          alt: ""
        }, null, 8, _hoisted_14)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })])), $setup.Client == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[11] || (_cache[11] = _createElementVNode("div", {
    style: {
      "font-size": "40px"
    }
  }, [_createElementVNode("h3", null, "知识科普")], -1)), _createElementVNode("div", {
    style: {
      "font-size": "25px"
    },
    onClick: _cache[3] || (_cache[3] = $event => $setup.go('member_science_m'))
  }, _cache[10] || (_cache[10] = [_createElementVNode("span", null, "全部 >", -1)]))])), _createElementVNode("div", {
    class: "member_index_nr",
    style: _normalizeStyle('width:' + ($setup.Client == 1 ? '90%;justify-content: space-between;margin:30px 0' : '80%;'))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data.top, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "nr_dome",
      style: _normalizeStyle('width:' + ($setup.Client == 1 ? '49%;padding:0px;margin-bottom:15px' : 'calc(100% / 3);'))
    }, [_createElementVNode("div", {
      class: "nr_dome_item",
      onClick: $event => $setup.details(item.id)
    }, [_createElementVNode("img", {
      src: item.imgUrl,
      alt: ""
    }, null, 8, _hoisted_18), _createElementVNode("h3", {
      style: _normalizeStyle('font-size:' + ($setup.Client == 1 ? '40px' : '20px'))
    }, _toDisplayString(item.title), 5), _createElementVNode("div", {
      class: _normalizeClass($setup.Client == 1 ? 'nr_data' : ''),
      style: _normalizeStyle(['font-size:' + ($setup.Client == 1 ? '2rem;' : '13pt;') + 'text-indent:' + ($setup.Client == 1 ? '3.5rem;' : '37px;'), {
        "font-family": "siyuan_Regular"
      }])
    }, _toDisplayString(item.brief), 7), $setup.Client == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("img", {
      src: item.userCollect == 0 ? 'https://www.mimodental.com/assets/imgData/imgs/wsc.png' : 'https://www.mimodental.com/assets/imgData/imgs/ysc.png',
      alt: ""
    }, null, 8, _hoisted_20), _createElementVNode("span", {
      style: _normalizeStyle('color:' + (item.userCollect == 0 ? '#000;' : '#13A4BF;'))
    }, _toDisplayString(item.collects), 5)])) : _createCommentVNode("", true)], 8, _hoisted_17)], 4);
  }), 128))], 4)], 4);
}